import React from "react";
import { joinClassnames } from "utils/map-modifier";

import "./index.scss";

interface ReserveProductDescProps {
  content: string;
  className?: string;
}

const ReserveProductDesc: React.FC<ReserveProductDescProps> = ({
  content,
  className,
}: ReserveProductDescProps) => {
  return (
    <div className={joinClassnames("m-reserve-product-desc_wrap", className)}>
      {(content && (
        <p className="m-reserve-product-desc_ctaDesc">{content}</p>
      )) ||
        null}
    </div>
  );
};

ReserveProductDesc.defaultProps = {};

export default ReserveProductDesc;
